import { LoaderFunctionArgs } from "react-router-dom";
import { Api } from "../api/Api";
import { SatelliteInfo, TleRec } from "../api/Application";
import { satIds } from "../common/FakeTwoLineElements";

export async function tleLoader( { params }: LoaderFunctionArgs ): Promise<[SatelliteInfo[], TleRec[]]> {
    const payload = { noradCatIds: satIds };
    const satRes = await Api.satelliteList();    
    if( !satRes.isOk ) {
        throw new Error( "Could not load Satellite Info!" );
    }

    const tleRes = await Api.twoLineELementList( payload );    
    if( !tleRes.isOk ) {
        throw new Error( "Could not load TLEs" );
    }
    return [satRes.value, tleRes.value];
}